export enum PaymentTransactionType {
    None = 0,
    Invoice = 1,
    CustomerPayment = 2,
    RefundInvoice = 3,
    RefundIssuance = 4,
    SalesTaxRebate = 5,
    Chargeback = 6,
    ChargebackAcknowledgement = 7,
}

